import KIAImage from '@/components/ui/image/KIAImage';
import { ModelType } from 'types';

function CardContainer({
  children,
  model,
}: {
  children: React.ReactNode;
  model: ModelType;
}) {
  return (
    <div className="grid">
      <article className="grid">
        <div className="grid relative lg:grid-cols-[1fr_1.5fr] items-center gap-6 lg:gap-12 max-w-screen-2xl w-full mx-auto px-4 py-10 lg:py-16 rounded-t-lg overflow-hidden">
          {model.first_car.image ? (
            <KIAImage
              className="w-full h-auto max-w-md lg:max-w-none object-contain mx-auto drop-shadow-xl"
              width={600}
              src={model.first_car.image}
              alt={model.name}
            />
          ) : null}
          <div className="text-center lg:text-left max-w-lg mx-auto">
            <span className="inline-flex items-center gap-2 bg-white border border-dark-blue/10 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide text-dark-blue shadow-sm mb-3">
              Snabbfakta
            </span>
            <h3 className="text-3xl lg:text-5xl font-extrabold text-dark-blue tracking-tight text-balance">
              {model.name}
            </h3>
            {model.description && (
              <p className="mt-3 text-base lg:text-lg text-slate-600">
                {model.description}
              </p>
            )}
          </div>
          <svg
            className="absolute inset-0 w-full h-full -z-10"
            width="100%"
            height="100%"
            viewBox="0 0 1440 560"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M0 0 L1440 0 L1440 560 Q720 450 0 560 Z" fill="#f7f7f7" />
          </svg>
        </div>
        {children}
      </article>
    </div>
  );
}

export default CardContainer;
